<p-dialog header="Download Selected Documents" [(visible)]="downloadVisible" [modal]="true" [closable]="false"
    [style]="{width:'50vw'}">
    <div class="row">
        <div *ngIf="itemCount > 0" class="col">
            <span class="h2">{{itemCount | number}}</span>
            <p>Items selected to download.</p>
            <p>Click 'Download Docs' to start the download.</p>
            <p>The items will be available in your downloads folder in 1 or more zip files depending on the file
                size(s), starting with the prefix <b>'aps_files'</b></p>
            <p *ngIf="hasLegacySelected()"><b><i><i class="fa fa-microscope text-primary"></i> NOTE: You have selected
                        Legacy Library items, These items will not be downloaded as there is no digital record for these
                        items.</i></b></p>
            <p *ngIf="itemCount > docMax"><b><i>NOTE: You have selected more than the maximum number of documents to be
                        downloaded {{docMax | number}}. <br /> Only the first {{docMax | number}} documents will be
                        downloaded!!</i></b></p>
        </div>
        <div *ngIf="itemCount < 1" class="col">
            <h1>{{itemCount | number}}</h1>
            <p>Items selected to download.</p>
            <p>Please select at least 1 item before attempting to download.</p>
        </div>
    </div>
    <div class="float-end">
        <button p-button class="btn btn-primary mt-3 mb-3 me-3" (click)="executeClose();"><span
                class="fas fa-circle-xmark"></span>
            Close
        </button>
        <button p-button class="btn btn-secondary mt-3 mb-3" [disabled]="itemCount < 1" (click)="executeDownload();">
            <span class="pi pi-download"></span> Download Docs</button>
    </div>
</p-dialog>
<p-dialog header="Downloading {{downloadCount | number }} Files" [(visible)]="isDownloading" [style]="{width:'50vw'}">
    <div class="align-items-center">
        <p>Your files are downloading. You can close this window, the files will be in your downloads folder when
            complete.</p>
        <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="float-end">
        <button p-button class="btn btn-primary mt-3 mb-3 me-3" (click)="closeProgressDialog();"><span
                class="fas fa-circle-xmark"></span>
            Close
        </button>
    </div>
</p-dialog>